import ko from 'knockout';
import $ from 'jquery';

    function LogiReportFormatter(params, observableOptions) {

        var self = this;

        self.observableOptions = observableOptions;

        self.reportName = params.reportName;
        self.logiSource = params.logiSource;

        self.observableFormattedData = ko.observable({});

        self.subscriptions = [];
    }

    function ComposeData(sourcedata, options, reportName, initFlag) {
        sourcedata.reportName = reportName;
        return sourcedata;
    }

    LogiReportFormatter.prototype.RefreshData = function () {
        var self = this;

        var sourceList = self.dataRepository.getDictionaryValue(self.dataRepository.logiReportParamsObservableDictionary, { logiSource: self.logiSource });

        if (sourceList)
            self.observableFormattedData(ComposeData(sourceList, self.observableOptions(), self.reportName));

    };

    LogiReportFormatter.prototype.DataUpdated = function () {
        var self = this;
        self.RefreshData();
    };

    LogiReportFormatter.prototype.OptionsUpdated = function () {
        var self = this;
        self.RefreshData();
    };


    LogiReportFormatter.prototype.initialize = function (dataRepository) {
        var self = this;

        self.dataRepository = dataRepository;

        self.subscriptions.push(self.dataRepository.logiReportParamsObservableDictionary.subscribe(function () { self.DataUpdated(); }));

        self.subscriptions.push(self.observableOptions.subscribe(function () { self.OptionsUpdated(); }));

        //initialize data if it is there, so that if it isn't a 'loading' icon will show on UI
        if (!$.isEmptyObject(dataRepository.logiReportParamsObservableDictionary()))
            self.RefreshData();
    };

    LogiReportFormatter.prototype.getObservableData = function () {
        var self = this;

        return self.observableFormattedData;
    };

    LogiReportFormatter.prototype.dispose = function () {
        var self = this;
        self.subscriptions.forEach(function (sub) {
            sub.dispose();
        });
    };

    export default LogiReportFormatter;
